import { LoadState } from "../../constants/enums";
import { defaultDrawingItem } from "../drawingItem/defaultState";
import { IDrawing, IDrawingItem, IDrawingState } from "./drawing.types";

export const initialDrawingItem: IDrawingItem = {
  drawing_item_uuid: null,
  drawing_name: "",
  drawing_link: "",
  drawing_no: "",
  status: "ACTIVE",
};

export const initialDrawing: IDrawing = {
  drawing_uuid: "",
  order_no: "",
  finish: "",
  assigned_to_uuid: null,
  assigned_to_name: null,
  region: "DTZ",
  rev_no: null,
  creation_status: "NEW",
  drawing_name: "",
  description: "",
  product_uuid: "",
  product_code: "",
  product_name: "",
  product_description: "",
  prepared_by_uuid: null,
  prepared_by_name: null,
  checked_by_uuid: null,
  checked_by_name: null,
  approved_by_uuid: null,
  approved_by_name: null,
  drawing_items: [defaultDrawingItem],
  approval_status: null,
  status: "DRAWING_REQUESTED",
  project_name: "",
};

export const initialDrawingState: IDrawingState = {
  list: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  newList: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  drawing: {
    data: initialDrawing,
    meta: "",
    loading: LoadState.NotLoaded,
    error: null,
  },
  approvalDrawingList: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  drawingItem: {
    data: initialDrawingItem,
    loading: LoadState.NotLoaded,
    error: null,
  },
  order_existing_drawings: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
